<template>
  <div>
		<a-tabs default-active-key="1" @change="tabChange">
			<a-tab-pane key="1" tab="库存变更">
        <div class="search-panel">
          <Json2Form
            :form="form"
            :fieldsSource="fieldsSource"
            :options="options"
            :btns="btns"
            formClass="json2form"
            @submit="handleSubmit"
            @cancel="resetForm"
            ref="search-form"
          />
        </div>
				<a-table
					:columns="changeColmns"
					:data-source="changeRecordData"
					:pagination="ipaginationTab1"
          :loading="tableLoading"
          :row-key="record => record.uuid"
          @change="handleTableChange"
          style="margin-top: 15px;"
				/>
			</a-tab-pane>
			<a-tab-pane key="2" tab="各规格库存" force-render>
        <a-spin :spinning="spinning">
          <a-table
            :columns="specsColmns"
            :data-source="specsData"
            :pagination="ipaginationTab2"
            :loading="tableLoading"
            :row-key="record => record.uuid"
            @change="handleTableChange"
          />
        </a-spin>
			</a-tab-pane>
		</a-tabs>
	</div>
</template>

<script>
import moment from 'moment';
import Json2Form from '@/components/Json2Form';
import { sotckRecordList, getItemGoods } from '@/api/goods/';
import { CHANGE_TYPE, CHANGE_TYPE_COLUMS } from '../constants/';
import { paginationItem } from '@/constants/goods/';

const fieldsSource = [
  {
    name: 'action',
    label: '变更类型',
    type: 'select',
    options: CHANGE_TYPE,
    span: 8,
  },
  {
    name: 'creator',
    label: '操作人',
    type: 'input',
    placeholder: '请输入内容',
    span: 8,
  },
  {
    name: 'create_time',
    label: '更新时间',
    type: 'range-picker',
    span: 8,
  },
];

export default {
  props: {
    uid: {
      type: String,
      required: true,
    },
  },
  components: {
    Json2Form,
  },
  data() {
    return {
      form: {},
      fieldsSource,
      changeColmns: CHANGE_TYPE_COLUMS, // 库存变更表头
      changeRecordData: [], // 库存变更数据
      specsColmns: [], // 各规格库存表头
      specsData: [], // 各规格库存数据
      tableLoading: false,
      spinning: false,
      tabIndex: 1,
      action: '', // 库存变更-变更类型
      btns: [
        {
          action: 'submit',
          text: '查询',
          style: {
            color: '#fff',
            background: '#345FEC',
            border: 'none',
          },
        },
        {
          action: 'reset',
          text: '重置',
          force: true,
        },
      ],
      ipaginationTab1: { // 库存变更记录分页
        current: 1,
        pageSize: 10,
        total: 0,
        ...paginationItem,
      },
      ipaginationTab2: { // 各规格库存分页
        current: 1,
        pageSize: 10,
        total: 0,
        ...paginationItem,
      },
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
      },
      options: {
        layout: 'inline',
        gutter: 12,
        labelCol: {
          xl: {
            span: 8,
          },
          xxl: {
            span: 6,
          },
        },
        wrapperCol: {
          xl: {
            span: 16,
          },
          xxl: {
            span: 18,
          },
        },
      },
    };
  },
  mounted() {
    this.handleSubmit();
  },
  methods: {
    // 重置表单
    resetForm() {
      this.form = {};
    },
    // tab切换
    tabChange(type) {
      this.tabIndex = Number(type);
      if (Number(type) === 2 && this.specsData.length === 0) {
        this.getGoodsStocks();
      }
    },
    // 获取库存变更记录
    handleSubmit() {
      const formData = this.$refs['search-form'].getFieldsValue();
      if (formData.create_time && formData.create_time.length > 0) {
        formData.create_time_start = moment(formData.create_time[0]).valueOf();
        formData.create_time_end = moment(formData.create_time[1]).valueOf();
      }
      delete formData.create_time;
      console.log(formData);
      this.tableLoading = true;
      sotckRecordList({
        ...formData,
        goods_uuid: this.uid,
        current: this.ipaginationTab1.current,
        page_size: this.ipaginationTab1.pageSize,
      }).then((res) => {
        this.tableLoading = false;
        this.changeRecordData = (res.items || []).map((v) => ({
          ...v,
          action: CHANGE_TYPE[CHANGE_TYPE.findIndex((o) => o.value === v.action)].label,
          attr: v.attr.join(';'),
          update_time: moment(v.update_time * 1000).format('YYYY-MM-DD HH:mm:ss'),
          change_num: v.change_type === 1 ? `+${v.change_num}` : `-${v.change_num}`,
        }));
        this.ipaginationTab1 = {
          current: res.current,
          pageSize: res.page_size,
          total: res.total,
          ...paginationItem,
        };
      });
    },
    // 获取各规格库存
    getGoodsStocks() {
      this.spinning = true;
      getItemGoods({
        uuid: this.uid,
      }).then((res) => {
        this.spinning = false;
        this.specsColmns = [];
        const columns = (res.attr || []).map((v) => ({
          title: v.key,
          dataIndex: v.key,
        }));
        this.specsColmns = [
          ...columns,
          {
            title: '现有库存',
            dataIndex: 'number',
          },
        ];
        this.specsData = JSON.parse(res.stocks);
        console.log(this.specsData);
      }, () => {
        this.spinning = false;
      });
    },
    // 分页改变
    handleTableChange(pagination) {
      if (this.tabIndex === 1) {
        this.ipaginationTab1.current = pagination.current;
        this.ipaginationTab1.pageSize = pagination.pageSize;
        this.handleSubmit();
      } else {
        this.ipaginationTab2.current = pagination.current;
        this.ipaginationTab2.pageSize = pagination.pageSize;
      }
    },
  },
};
</script>

<style lang="less" scoped>

</style>
